<template>
  <div class="page">
    <Header no_recharge></Header>
    <div class="container">
      <div class="left">
        <img class="logo" src="@/img/logo.png" alt="" />
        <!-- <p class="name">Yaychat</p> -->
        <p class="desc">
          Join our free and exciting voice chat app! Share stories, ideas, and
          join online parties anytime, anywhere. Add some fun with interactive
          features in the app!
        </p>
       
      </div>
      <img class="right_img" src="@/img/car_box.png" alt="" />
    </div>
    <p class="b_t">{{ $t('sl.registerNowAndFillInTheInvitationCodeToGetAFancyCar') }}</p>
    <div class="invite_code flex-alc flex-center">
        <div class="label">{{ $t('sl.invitationCode') }}</div>  
        <div class="lg-b b6">
          <div class="code ">
            <span class="i_c">{{CODE}}</span>
          </div>
        </div> 
    </div>
     <div class="flex-center download_btn">
          <!-- <img onclick="window.open('https://apps.apple.com/us/app/yaychat-voice-chat-rooms/id6459409309')" class="way" -->
          <img @click="download('apple')" class="way"
            src="@/img/app-store-badge.svg" alt="" />
          <!-- <img class="way" onclick="window.open('https://play.google.com/store/apps/details?id=chat.yay.app')" -->
          <img class="way"  @click="download('gg')"
            src="@/img/google-play-badge.svg" alt="" />
          <!-- <img v-if="isAndroid()" onclick="window.open('https://cdn.yay1.xyz/apks/yaychat-gw.apk')" class="d_icon"
            src="@/img/android_icon.svg" alt=""> -->
        </div>
    <div class="c_r flex-center">
      <div class="left">{{ $t('sl.copyright2023YaychatAllRightsReserved') }}</div>
      <div class="right flex-alc">
        <div class="link" onclick="window.open('https://www.yay.chat/agreements/UserAgreement.html')">
          User Agreement
        </div>
        <span class="shu"></span>
        <div class="link" onclick="window.open('https://www.yay.chat/agreements/PrivacyPolicy.html')">
          Privacy Policy
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { showNotify  } from 'vant';
import { isAndroid } from "#/utils/index.js"
import Header from '#/components/Header/index.vue'
import useClipboard from 'vue-clipboard3';
import { useRoute } from 'vue-router'
import {ref} from 'vue'
const route = useRoute()

const CODE = ref(route.query.IC);
let INVITE_TEXT=`#^yc:${CODE.value}^#`
const { toClipboard } = useClipboard();
async function  download(type){
 await toClipboard(INVITE_TEXT)
    
 console.log(`复制成功,${INVITE_TEXT}`)
 showNotify({ type: 'success', message: 'Invitation code copyed successfully' });
 setTimeout(()=>{
  to_download_page(type)
 },2000)
 
}

function to_download_page(type){
    if(type == 'apple'){
     window.location.href="https://apps.apple.com/us/app/yaychat-voice-chat-rooms/id6459409309"
   }
   if(type == 'gg'){
    //  window.location.href('https://play.google.com/store/apps/details?id=chat.yay.app')
     window.location.href="https://play.google.com/store/apps/details?id=chat.yay.app"
   }
}
</script>

<style lang="scss" scoped>
* {
  padding: 0;
  margin: 0;
}

html {
  overflow-x: hidden;
}

.page {
  width: 100vw;
  min-height: 100vh;
  // background: url('../../assets/img/bg.png') no-repeat;
  background: url('../../assets/img/main_site_bg.png') rgba(211, 211, 211, 0.116) 50% / cover no-repeat;
  // background-size: cover;
  position: relative;
  box-sizing: border-box;
  padding: 0 0px;
  padding-top:180px;
  display: flex;
  flex-direction: column;
  // justify-content: space-between;
}

.logo {
  width: 210px;
  margin-top: 58px;
  margin-bottom: 10px;
}

.c_r {
  width: 100vw;
  box-sizing: border-box;
  color: rgb(209, 206, 206);
  font-size: 14px;
  left: 0;
  right: 0;
  margin: 0 auto;
  text-align: center;
  padding: 20px 0px;
  background: #161616;
  position: fixed;
  bottom: 0;
}

.right_img {
  width: 30%;
}

.left {
  margin-right: 60px;
}

.container {
  width: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  left: 0;
  right: 0;
  margin: 0 auto;
}

.name {
  color: #333;
  font-size: 80px;
  font-weight: 700;
}

.desc {
  max-width: 610px;
  word-break: break-all;
  color: #333;
  font-size: 24px;
  margin-bottom: 20px;
  font-weight: normal;
}

.way {
  // margin: 0 15px;
  height: 60px;
  cursor: pointer;
  // width: 200px;
}

.flex {
  display: flex;
}

.flex-between {
  display: flex;
  justify-content: space-between;
}

.flex-center {
  display: flex;
  justify-content: center;
}

.flex-alc {
  display: flex;
  align-items: center;
}

.link {
  font-size: 14px;
  color: rgb(209, 206, 206);
  cursor: pointer;
}

.link:hover {
  text-decoration: 1px solid underline;
}

.shu {
  width: 1px;
  height: 17px;
  background: #666666;
  margin: 0 20px;
}
.b_t{
  box-sizing: border-box;
  padding: 0 20px;
  // width: 90px;
  color: #333;
  text-align: center;
  font-family: 'Poppins';
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
}
.invite_code{
  margin-top: 20px;
  margin-bottom: 40px;
  .label{
    color: #333;
    text-align: center;
    font-family: 'Poppins';
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    margin-right: 6px;
    
  }
  .code{
    width: 90px;
    height: 32px;
    border-radius: 6px;
    text-align: center;
    line-height: 32px;
    border-radius: 6px !important;
    padding: 4px 12px;
    border: 1px solid var(rgba(255, 95, 177, 1), rgba(72, 67, 254, 1));
    background: linear-gradient(244deg, rgba(255, 95, 177, 0.10) 17.61%, rgba(72, 67, 254, 0.10) 83.67%);
    .i_c{
      display: inline-block;
      line-height: 32px;
      font-size: 24px;
      font-weight: 700;
      font-family: 'Poppins';
      background: linear-gradient(244deg, #FF5FB1 17.61%, #4843FE 83.67%);
      background-clip: text;
      -webkit-background-clip: text;
      color: transparent;
    }
  }
}
.b6{
  border-radius: 12px;
}
@media screen and (max-width:767px) {
  .page{
    padding-top: 60px;
    padding-bottom: 100px;
  }
  .container {
    width: 90%;
    flex-wrap: wrap;
    // padding-bottom: 100px;

    .left {
      width: 100%;
      margin-right: 0;
      text-align: center;

    }

    .right_img {
      width: 100%;
    }
  }

  .c_r {
    flex-wrap: wrap;

    .left {
      margin-right: 0;
    }
  }

  .way {
    height: 40px;
    margin: 0 !important;
    padding-bottom: 10px;
  }

  .d_icon {}

  .download_btn {
    // flex-direction: column;
    // align-items: center;
    width: 100% !important;
    flex-wrap: wrap;
    justify-content: center;
    img {
      width: 160px;
      height: 48px;
      margin: 0 10px !important;
      margin-right: 0 !important;
    }

    // justify-content: space-around;
    // flex-wrap: wrap;
  }
}

.download_btn {
  width: 100%;
  box-sizing: border-box;
  // padding: 0 10px;
  // justify-content: space-around;
  // flex-wrap: wrap;

  img {
    // width: 30%;
    margin-right: 20px;
  }

  .d_icon {
    width: 60px;
  }
}

.logo {
  width: 100px;
}

.name {
  font-size: 40px;
}

.desc {
  font-size: 20px;
}
</style>